export const loadDetailsModal = () => import(/* webpackChunkName: 'details-modal' */ './detailsModal/detailsModal');
export const loadMediaOverlay = () => import(/* webpackChunkName: 'media-overlay' */ './mediaOverlay/mediaOverlay');
export const loadVariantSelection = () =>
    import(/* webpackChunkName: 'variant-selection' */ './variantPanel/variantSelection/variantSelection');
